<template>
  <div class="row">
    <div class="col-md-7">
      <span :class="[$style.cancellation__heading3, 'mb-3']">{{ user.firstname }}, não deixe sua jornada terminar aqui</span>

      <span :class="[$style.cancellation__heading1, 'mb-3']">O caminho para o sucesso possui diversas barreiras e uma
        delas é a vontade de desistir. Não se esqueça do dia que resolveu tomar a decisão de investir em conhecimento
        para buscar <strong>seus objetivos.</strong></span>

      <span :class="[$style.cancellation__heading2, 'mb-4']">Até agora crescemos muito juntos, e com certeza podemos
        crescer muito mais ainda! Você não está sozinho nessa.</span>

      <div class="text-center mt-3">
        <button
          :class="[$style.cancellation__button1, 'mr-3']"
          @click="confirmCancellation"
        >Cancelar assinatura</button>

        <SecondaryButton
          :class="$style.cancellation__button2"
          @click="() => goBackFromCancellation({ type: 'INICIAL' })"
        >Continuar minha jornada</SecondaryButton>
      </div>
    </div>

    <div class="col-md-5">
      <CancellationCard v-if="courses.length" class="mb-3">
        <template #title>Cursos em andamento</template>
        <template #subtitle>Não abandone o conhecimento que poderá ser essencial para sua jornada</template>
        <template #content>
          <div :class="[$style.cancellation__courseList]">
            <CourseThumb v-for="course in courses" :key="course.id" :course="course" />
          </div>
        </template>
      </CancellationCard>

      <CancellationCard v-if="certificates.length" class="mb-3">
        <template #title>Certificados conquistados</template>
        <template #subtitle>Continue colocando em prática todo o aprendizado adquirido até agora</template>
        <template #content>
          <div :class="[$style.cancellation__courseList]">
            <CourseBasicItem v-for="certificate in certificates" :key="certificate.id" :course="certificate.course"
              class="mb-3">
              <template #name>&nbsp;</template>
            </CourseBasicItem>
          </div>
        </template>
      </CancellationCard>

      <CancellationCard v-if="userTrail">
        <template #title>Trilha de {{ userTrail.name }}</template>
        <template #subtitle>Continue evoluindo e adquirindo conhecimento para conquistar seus objetivos</template>
        <template #content>
          <div :class="[$style.teachers, 'mb-3']">
            <div v-for="author in userTrail.authors" :key="author.avatar" :class="$style.teachers__item"
              :style="`background-image: url(${author.avatar})`"></div>
          </div>

          <BaseProgressBar :value="userTrail.trail_attended_percent" />
        </template>
      </CancellationCard>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { ref } from '@vue/composition-api'
import { useUserTrail } from '@/components/trail/trail'
import { getUserCoursesOngoing } from '@/api/course.api'
import { getCertificatesByUser } from '@/api/certificate.api'
import CourseThumb from '@/components/course/CourseThumb'
import CourseBasicItem from '@/components/course/CourseBasicItem'
import BaseProgressBar from '@/components/progressbar/BaseProgressBar'
import CancellationCard from '@/components/cancellation/CancellationCard'
import useCancellation from '@/components/cancellation/cancellation'
import SecondaryButton from '@/components/buttons/SecondaryButton'

export default {
  components: {
    CourseThumb,
    CourseBasicItem,
    BaseProgressBar,
    CancellationCard,
    SecondaryButton,
  },
  setup(props, { emit }) {
    const { userTrail } = useUserTrail()
    const user = store.getters['user/user']
    const courses = ref([])
    const certificates = ref([])
    const { goBackFromCancellation } = useCancellation()

    function confirmCancellation () {
      emit('confirm-cancellation')
    }

    getUserCoursesOngoing(user.id, { perPage: 6 })
      .then(res => res.data.forEach(course => courses.value.push(course)))

    getCertificatesByUser(user.id, { perPage: 6 })
      .then(res => res.data.data.forEach(certificate => certificates.value.push(certificate)))

    return {
      user,
      userTrail,
      courses,
      certificates,
      confirmCancellation,
      goBackFromCancellation
    }
  }
}

</script>

<style lang="scss" module>
@import "~@/components/cancellation/cancellation.scss";

.teachers {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.teachers__item {
  width: 40px;
  aspect-ratio: 1/1;
  background-size: cover;
  border-radius: 100%;
  border: 2px solid #fff;
  margin-left: -5px;
}
</style>